'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Byline = exports.ThemedByline = exports.ContextualByline = exports.default = undefined;

var _Byline = require('./Byline');

var _Byline2 = _interopRequireDefault(_Byline);

var _ContextualByline = require('./ContextualByline');

var _ContextualByline2 = _interopRequireDefault(_ContextualByline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ThemedContextualByline = (0, _ContextualByline2.default)(_Byline2.default);
var ContextualByline = (0, _ContextualByline2.default)(_Byline.Byline);

exports.default = ThemedContextualByline;
exports.ContextualByline = ContextualByline;
exports.ThemedByline = _Byline2.default;
exports.Byline = _Byline.Byline;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-byline/lib/cjs/index.js
 ** module id = 285
 ** module chunks = 1
 **/